module.exports = __webpack_public_path__ + "img/创建标签.0ff80c30.svg";